module.exports = __webpack_public_path__ + "img/xgboost_vs_rf.bccf6447.png";